import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="dictionaryAppWrapper">
      <div className="dictionaryApp">
        <h1>Dictionary</h1>
        <Dictionary />
      </div>
    </div>
  );
}
